import { COSIGN_X_PLATFORM_TOKEN, USER_SELECTED_LANG_COOKIE } from '@constants'
import { getCountryCodeFromPathname } from '@utils'
import Cookies from 'js-cookie'

/**
 * @deprecated
 */
export const getXPlatformToken = () => {
  return Cookies.get('x-platform-token')
}

/**
 * @deprecated
 * Please use getWordPressLocale from libs/utils/src/getLocal.ts
 */
export const getLocale = () => {
  return Cookies.get(USER_SELECTED_LANG_COOKIE) || 'zh_TW'
}

/**
 * @deprecated
 * Please use getWpUserRegion
 */
export const getUserRegion = () => {
  return getCountryCodeFromPathname(window.location.pathname, 'TW')
}

export const getDniJwtToken = () => {
  return Cookies.get('dni_jwt_token')
}

export const getAccount = () => {
  return Cookies.get('account')
}

export const resetCosignCookies = () => {
  Cookies.remove('account')
  Cookies.remove('country_code')
}

export const getXPlatformTokenWithCode = (code?: string) => {
  return Cookies.get(`${code}_${COSIGN_X_PLATFORM_TOKEN}`)
}
